// extracted by mini-css-extract-plugin
export default {"youtubePopup":"youtubePopup__ZfnjL","closePopup":"closePopup__6OgBX"};